import React from 'react';

const LoadingSpinner = () => <div className="loader" />

export default LoadingSpinner;